<template>
    <b-button
        @click="$emit('click', $event)"
        class="rkm-navbar-nav-icon"
        pill
    >
        <rkm-icon icon="bars" />
    </b-button>
</template>

<script>
// Components.
import {BButton} from 'bootstrap-vue'

export default {
    components: {BButton},
}
</script>

<style lang="scss" scoped>
$primary: #007bff;

.rkm-navbar-nav-icon {
    background-color: darken($primary, 10%) !important;
    border: none;
    height: 40px;
    width: 40px;
}
.rkm-navbar-nav-icon:hover {
    background-color: darken($primary, 15%) !important;
}
.rkm-navbar-nav-icon:active {
    background-color: darken($primary, 15%) !important;
    box-shadow: none !important;
}
.rkm-navbar-nav-icon:focus {
    background-color: darken($primary, 15%) !important;
    box-shadow: none !important;
}
</style>